import React, { useReducer } from "react";
import { Tabel, DropDown, DropDownMenu, Modal } from "../core";
import { reducer, initialState } from "../hooks/modalReducer";

import { Menu } from "antd";
import EditSizerQualityRate from "./EditSizerQualityRate";
import DeleteSizerRate from "./DeleteSizerRate";

const invoice = [
  {
    title: "SR #",
    dataIndex: "SNo",
    key: "S.No",
    render: (text, record, index) => {
      return <span>{index + 1}</span>;
    },
    width: 150,
  },
  {
    title: "Quality",
    dataIndex: "quality",
    key: "quality",
    width: 150,
  },
  {
    title: "Rates/Kg (Rs)",
    dataIndex: "rate_per_kg",
    key: "rate_per_kg",
    width: 150,
  },
  {
    title: "",
    dataIndex: "action",
    width: 150,
    render: (text, record, index) => (
      <DropDown
        overlay={<MenuCompo index={index} record={record} />}
        record={record}
      />
    ),
  },
];
const invoiceData = [];
for (let i = 0; i < 46; i++) {
  invoiceData.push({
    SNo: i + 1,
    key: i + 1,
    quality: "Khaddi",
    rates: "567",
  });
}
const SizerRates = ({
  pagination,
  SizerData,
  sizerRates,
  className,
  props,
}) => {
  console.log(sizerRates);
  return (
    <Tabel
      {...props}
      className={className}
      padding="0px"
      pagination={pagination}
      columns={invoice}
      data={sizerRates}
    />
  );
};
const MenuCompo = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  function clickHandler(params) {
    dispatch({
      type: "MODAL_VIEW",
      payload: { flag: true, modal_name: params },
    });
  }
  const onCreate = (values) => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };

  return (
    <div>
      <DropDownMenu>
        <Menu.Item
          className="menu--item"
          key="delete"
          onClick={() => clickHandler("delete sizer rate")}
        >
          Delete
        </Menu.Item>
        <Menu.Item
          className="menu--item"
          key="edit"
          onClick={() => clickHandler("edit sizer rate")}
        >
          Edit
        </Menu.Item>
      </DropDownMenu>
      {state.modal_name === "edit sizer rate" ? (
        <Modal
          closable={false}
          visible={state.visible}
          onCreate={onCreate}
          footer={false}
          maxwidth="589px"
          onCancel={() => dispatch({ type: "MODAL_VIEW", payload: false })}
          tittle="Edit Sizer Rate"
        >
          <EditSizerQualityRate />
        </Modal>
      ) : state.modal_name === "delete sizer rate" ? (
        <Modal
          closable={false}
          visible={state.visible}
          onCreate={onCreate}
          footer={false}
          maxwidth="589px"
          onCancel={() => dispatch({ type: "MODAL_VIEW", payload: false })}
        >
          <DeleteSizerRate />
        </Modal>
      ) : null}
    </div>
  );
};
export default SizerRates;
